import { NCFileLevelSubScreen } from '@v2/pages/nc-file/details/common/enums/ncFileDetails.enum';

export const TRACEABILITY_BATCH_LIMIT = 5;

// Main details screen names the graph's cards tap through to. Inlined as literals to
// avoid importing the nc-file navigation config (circular import → TDZ at runtime).
export const DETAILS_SCREEN_NAMES = {
  batch: 'BatchDetails',
  job: 'JobDetailsV2',
  part: 'PartDetailsV2',
  productionOrder: 'ProductionOrderDetailsV2',
};

// Strips the trailing level-sub-screen segment from the current route name so we can
// re-target a sibling NC-file sub-screen within whatever perspective hosts the tab.
export const NC_FILE_SUB_SCREEN_SUFFIX_REGEXP = new RegExp(`(?:${Object.values(NCFileLevelSubScreen).join('|')})$`);

export const TRACEABILITY_BATCH_SELECT = [
  'ProductionBatchId',
  'BatchNumber',
  'MachineId',
  'MachineShortName',
  'MachineFullName',
  'NcFileId',
  'NcFileName',
  'NcFileStatus',
  'StartedOn',
  'EndedOn',
  'IsClosed',
  'IsInProgress',
  'Quantity',
  'Links',
  'ImageHash',
  'ImageDocumentId',
];
